import $ from "cash-dom";

export default class VideoModule {

    static name = 'video'

    constructor(node) {

        const $node = $(node);
        const ytid = $node.data('ytid')

        /*if($node.data('inline')) {
            $node.on('click', handleVideoInline)
        } else {
            $node.on('click', handleVideoInStickyPlayer)
        }*/
        $node.on('click', handleVideoInStickyPlayer)

        function handleVideoInline(e) {

            e.preventDefault()

            const markup = `<div class="iframehelper" style="padding-top: 56.25%;">
			    <iframe title="iframe-player" src="https://www.youtube.com/embed/${ytid}?autoplay=1" width="640" height="360" frameborder="0" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
            </div>`
            
            $node.parent().removeClass('video').css('background-image', 'none');
            $node.replaceWith(markup)
                
        }

        function handleVideoInStickyPlayer(e) {

            e.preventDefault()

            const videoIndex = $('#playlist-youtube > li[data-ytid="'+ ytid +'"]').index()
            const ytPlaylistIndex = $('#playlists > li[data-source="playlist-youtube"]').index()
    
            if(ytPlaylistIndex === window.player1.data.prevId) {
                window.player1.playSpecificTrack(ytPlaylistIndex, videoIndex)
            } else {
                //if the playlist is not active, load it and then play
                window.player1.loadPlaylist(ytPlaylistIndex)
                window.player1.addListener(FWDMSP.LOAD_PLAYLIST_COMPLETE, () => {
                    window.player1.playSpecificTrack(ytPlaylistIndex, videoIndex)
                }, { once: true })
            }
        }
    }
}